import React from 'react';
import { TrevorIcon, TrevorComponent } from '@trevor/ui-components';
import { LinkedinProps } from './types';
import createLinkFor from './createLinkFor';
import openWindow from './openWindow';

const Linkedin: TrevorComponent<LinkedinProps> = ({ title, url }) => {
  return (
    <TrevorIcon
      name="linkedin"
      size={48}
      onClick={() =>
        openWindow(
          createLinkFor('linkedin', {
            mini: 'true',
            url,
            title,
          }),
        )
      }
      className="socialButton"
    />
  );
};

export default Linkedin;
